import React, { MutableRefObject, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useAuthentication } from 'hooks/useAuthentication'
import { useWallet } from '@solana/wallet-adapter-react'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'
// third party components
import { Menu as HMenu } from '@headlessui/react'

// resources
import SingleNftIcon from 'assets/icons/menu-single-nft-icon.svg?component'
import EditionIcon from 'assets/icons/menu-edition-nft-icon.svg?component'
import CollectionIcon from 'assets/icons/menu-collection-nft-icon.svg?component'
import EAIcon from 'assets/icons/menu-import-art-icon.svg?component'
import MerchIcon from 'assets/icons/menu-store-item-icon.svg?component'

// styles
import styles from './index.module.scss'
import { useRouter } from 'next/router'

const CreateMenu = () => {
  const { profileInfo } = useAuthentication()
  const router = useRouter()
  const dispatch = useDispatch()
  const { setVisible } = useWalletModal()
  const { connected } = useWallet()
  const menuRef = useRef<HTMLElement | null>(null)
  const itemRef = useRef<HTMLElement | null>(null)

  const [isMenuOpen, setIsMenuOpen] = React.useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleClickOutside = event => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      itemRef.current &&
      !itemRef.current.contains(event.target)
    ) {
      setIsMenuOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })

  return (
    <div className="flex items-center">
      <HMenu>
        <HMenu.Button ref={itemRef as MutableRefObject<HTMLButtonElement>}>
          <div
            className={styles.container}
            onClick={() => {
              if (!connected) {
                setVisible(true)
              } else {
                toggleMenu()
              }
            }}
          >
            <div>Create</div>
          </div>
        </HMenu.Button>
        {isMenuOpen && (
          <div ref={menuRef as MutableRefObject<HTMLDivElement>} className={styles.menuArea}>
            <div className="flex flex-col">
              <div
                className={styles.topSection}
                onClick={() => {
                  dispatch({ type: 'set', createTab: 0 })
                  router.push('/create/single-nft')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <SingleNftIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Single</div>
                    <div className={styles.desc}>One of a kind artwork</div>
                  </div>
                </div>
                <div className={styles.border} />
              </div>
              <div
                className={styles.middleSection}
                onClick={() => {
                  dispatch({ type: 'set', createTab: 1 })
                  router.push('/create/single-nft')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <EditionIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Editions</div>
                    <div className={styles.desc}>Multiple editions of the same artwork</div>
                  </div>
                </div>
                <div className={styles.border} />
              </div>
              <div
                className={styles.middleSection}
                onClick={() => {
                  dispatch({ type: 'set', mintCollectionStep: 1 })
                  dispatch({ type: 'set', collectionMintAddress: '' })
                  dispatch({ type: 'set', collectionCoverUrl: '' })
                  dispatch({ type: 'set', collectionKind: 'foster' })
                  router.push('/create/collection')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <CollectionIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Collection</div>
                    <div className={styles.desc}>Collection to nest a group of artwork</div>
                  </div>
                </div>
                <div className={styles.border} />
              </div>
              <div
                className={styles.middleSection}
                onClick={() => {
                  router.push('/import-artwork')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <EAIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Import Artwork</div>
                    <div className={styles.desc}>Import artwork from other platforms</div>
                  </div>
                </div>
                <div className={styles.border} />
              </div>
              <div
                className={styles.bottomSection}
                onClick={() => {
                  router.push(`/${profileInfo.username.replaceAll(' ', '%20')}/merch/new`)
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <MerchIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Store Item</div>
                    <div className={styles.desc}>Publish a physical item to your store</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </HMenu>
    </div>
  )
}

export default CreateMenu
